import { useNavigate } from "react-router-dom";
import type { PodcastResponse } from "../../types/api";
import styles from "./PodcastCard.module.css";

interface PodcastCardProps {
  podcast: PodcastResponse;
  organizationId: string;
}

export function PodcastCard({ podcast, organizationId }: PodcastCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/organizations/${organizationId}/podcasts/${podcast.id}`);
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
      tabIndex={0}
      className={styles.card}
    >
      <div className={styles.artwork}>
        {podcast.coverArtworkUrl ? (
          <img
            src={podcast.coverArtworkUrl}
            alt={`${podcast.name} cover`}
            className={styles.artworkImage}
          />
        ) : (
          <div className={styles.artworkPlaceholder}>
            <svg
              className={styles.micIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
              <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
              <line x1="12" y1="19" x2="12" y2="23" />
              <line x1="8" y1="23" x2="16" y2="23" />
            </svg>
          </div>
        )}
        {podcast.isPremium && <span className={styles.premiumBadge}>Premium</span>}
      </div>
      <div className={styles.content}>
        <h3 className={styles.name}>{podcast.name}</h3>
        {podcast.description && <p className={styles.description}>{podcast.description}</p>}
        <div className={styles.meta}>
          <span className={styles.episodeCount}>
            {podcast.episodeCount ?? 0} {(podcast.episodeCount ?? 0) === 1 ? "episode" : "episodes"}
          </span>
          <span className={styles.language}>{podcast.language.toUpperCase()}</span>
        </div>
      </div>
    </div>
  );
}
